// utils/getStatusColor.js

/**
 * Maps IVR or BAA status strings to Chakra UI badge color schemes.
 * @param {string} status - The status string (e.g. "in progress", "approved").
 * @returns {string} - The corresponding Chakra UI color scheme.
 */
const getStatusColor = (status) => {
  switch (status) {
    case 'in progress':
      return 'yellow';
    case 'awaiting documents':
      return 'orange';
    case 'signed':
      return 'blue';
    case 'submitted':
      return 'purple';
    case 'approved':
      return 'green';
    case 'denied':
      return 'red';
    default:
      return 'gray';
  }
};

export default getStatusColor;
